// CustomMenu.tsx
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SxProps, Theme, ThemeProvider, useMediaQuery } from '@mui/material'; 
import CssBaseline from '@mui/material/CssBaseline';
import DrawerComponent from './Drawer/Drawer'; 
import AppBarComponent from './AppBar'; 
import theme from '../../style/theme';  

/**
 * カスタムメニューコンポーネントのプロパティ型
 */
interface MiniDrawerProps {
  children: React.ReactNode; // 子コンポーネントの内容
}

/**
 * カスタムメニューコンポーネント
 * - AppBarとDrawerを含むレイアウトを提供する
 * - レスポンシブ対応（モバイル：600px以下）
 * - props: children（メインコンテンツ）
 */
export default function MiniDrawer({ children }: MiniDrawerProps) {
  const [open, setOpen] = React.useState(false);

  // ドロワーを開く
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  // ドロワーを閉じる
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const isMobile = useMediaQuery('(max-width:600px)');

  
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBarComponent open={open} handleDrawerOpen={handleDrawerOpen} />
        <DrawerComponent open={open} handleDrawerClose={handleDrawerClose} />
        
        {/* メインエリア*/}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh', 
            position: 'relative',
            background: 'repeating-linear-gradient(45deg, rgba(173, 216, 230, 0.2), rgba(255, 182, 193, 0.2) 10px, rgba(173, 216, 230, 0.2) 10px, rgba(255, 182, 193, 0.2) 20px)',
            backgroundSize: '20px 20px',
            top: isMobile ? '48px' : '56px',
            p: 0,
            width: isMobile ? "100%" : "auto"
          }}
        >

          {/* メインエリアの内容を追加*/}
          {children}
          
         {/* 著作権情報*/}
        <Box
        sx={{
          textAlign: 'center',
          width:'100%',
          mt:'auto',
          p: 1,
          background:'linear-gradient(to right, rgba(173, 216, 230, 0.5), rgba(255, 182, 193, 0.5))', 
        }}
      >
        <Typography variant="body2" color="textSecondary">
          © 2025 MÖBIUS Co., Ltd.
        </Typography>
      </Box> 
        </Box>
        </Box>
        </ThemeProvider>
    )}